import Scores from "./scores";

export default Scores;
